import React from 'react'
import classNames from 'classnames'
import { useSelector } from 'react-redux'
import { selectToken } from 'store/users/users.selectors'

import { InlineIcon } from '@iconify/react'
import fileZipOutlined from '@iconify/icons-ant-design/file-zip-outlined'

import { getDateFromServerDate, getDateTimeForWeb, setLocalTimezone } from 'utils/date'

import ButtonIcon from 'components/molecules/ButtonIcon'
import { Icon, IconType } from 'components/atoms/Icon'
import classes from '../../InputFile.module.css'

import { FileProps } from '../../../../../types/file'

type GalleryItemProps = {
  file: FileProps
  deletable?: boolean
  onDelete?: (file: FileProps) => void
  deleteLoading?: boolean
}

export const GalleryItem: React.FC<GalleryItemProps> = ({ file, deletable, onDelete, deleteLoading }) => {
  const { uuid, name, isLoading, progress, createdAt } = file
  const token = useSelector(selectToken)
  if (uuid)
    return (
      <div className={classNames('d-flex flex-row w-100 align-items-center justify-content-between', { 'mb-2': deletable })}>
        <a
          href={`${process.env.REACT_APP_FILES_SERVER}/file/${uuid}?token=${token}`}
          target="_blank"
          rel="noopener noreferrer"
          className="overflow-hidden w-100"
        >
          <div className={classNames(classes.galleryItem, uuid ? classes.hasButDownload : '')}>
            <div className="d-flex">
              <div style={{ flex: 1, minWidth: 0 }}>
                <div style={{ display: 'flex' }}>
                  <InlineIcon icon={fileZipOutlined} width={24} height={24} style={{ marginRight: '8px' }} />
                  <div className={classes.galleryItemFileName}>{name}</div>
                </div>
              </div>
              {createdAt ? (
                <span className="text-secondary">{getDateTimeForWeb(setLocalTimezone(getDateFromServerDate(createdAt || '')))}</span>
              ) : null}
            </div>
            {isLoading ? <progress max={100} value={progress} className={classes.progressBar} /> : null}
          </div>
        </a>
        {deletable && (
          <ButtonIcon
            variant="outline-dark"
            onClick={() => onDelete?.(file)}
            className={classNames('p-1 ml-2 mr-2 d-flex justify-center', classes.deleteIconBtn)}
            isLoading={deleteLoading}
          >
            <Icon className={classes.deleteIcon} type={IconType.Trash} width="20px" height="20px" />
          </ButtonIcon>
        )}
      </div>
    )
  return (
    <div className={classNames(classes.galleryItem, uuid ? classes.hasButDownload : '')}>
      <div>
        <InlineIcon icon={fileZipOutlined} width={24} height={24} style={{ marginRight: '8px' }} />
        <span>{name}</span>
      </div>
      {isLoading ? <progress max={100} value={progress} className={classes.progressBar} /> : null}
    </div>
  )
}

export default GalleryItem
